import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { marked } from 'marked';

@Injectable({
  providedIn: 'root'
})
export class MarkdownFormatterService {

  constructor(private sanitizer: DomSanitizer) {
    const renderer = new marked.Renderer();
    renderer.table = (header: string, body: string) =>
      `<div class="table-wrapper"><table><thead>${header}</thead><tbody>${body}</tbody></table></div>`;

    // O sanitizador do Angular remove `<input>`, e a lista de tarefas perdia a
    // marca junto — sobrava só o texto, sem distinguir feito de pendente.
    renderer.checkbox = (checked: boolean) =>
      `<span class="task-check${checked ? ' task-check--done' : ''}" aria-hidden="true"></span>`;

    marked.setOptions({
      renderer,
      gfm: true,
      breaks: true,
      silent: true
    });
  }

  format(markdownText: string): string {
    if (!markdownText) {
      return '';
    }

    const normalized = this.normalizeMarkdown(markdownText);
    const rawHtml = marked.parse(normalized) as string;
    return this.sanitizer.sanitize(SecurityContext.HTML, rawHtml) || '';
  }

  private normalizeMarkdown(text: string): string {
    return text
      .replace(/\n{3,}/g, '\n\n')
      .replace(/```(\w+)?\n/g, '\n```$1\n')
      .trim();
  }
}
